import React, {useEffect, useState, useContext} from 'react';
import { useParams } from 'react-router-dom';
import {API_HOST, fetcher, downloadFile, formatFileSize} from '../../config/config';
import {AppContext} from '../../config/context';
import Loader from "../../components/Loader/Loader";

export default function EntryComments(){
	const context = useContext(AppContext);
	const {project_id, tab_id, entry_id } = useParams();
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeUser, setActiveUser] = useState(0);
  const [downloadProgress, setDownloadProgress] = useState({});

  const getFile = async (comment, upload) => {
    const progressKey = `${comment.id}-${upload.id}`;
    await downloadFile(
      `${API_HOST}projects/${project_id}/tabs/${tab_id}/entries/${entry_id}/comment/${comment.id}/upload/${upload.id}/download`,
      upload.name,
      true,
      (progress) => setDownloadProgress((prev) => ({ ...prev, [progressKey]: progress }))
    );
    setDownloadProgress((prev) => { const { [progressKey]: _, ...rest } = prev; return rest; });
  }

  const getAllFiles = async (comment) => {
    const progressKey = `all-${comment.id}`;
    const now = new Date();
    const date = now.toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\./g, '-');
    const time = now.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', second: '2-digit' }).replace(/:/g, '-');
    await downloadFile(
      `${API_HOST}projects/${project_id}/tabs/${tab_id}/entries/${entry_id}/comment/${comment.id}/download_all`,
      `Download_${date}_${time}.zip`,
      true,
      (progress) => setDownloadProgress((prev) => ({ ...prev, [progressKey]: progress }))
    );
    setDownloadProgress((prev) => { const { [progressKey]: _, ...rest } = prev; return rest; });
  }

	useEffect(() => {
		(async () => {
      const comments = await fetcher(`${API_HOST}projects/${project_id}/tabs/${tab_id}/entries/${entry_id}/comments`);
			setComments(comments);
      setLoading(false);
		})();
	}, [project_id, tab_id, entry_id]);

	useEffect(() => {
    setActiveUser(context.user?.id);
	}, [context.user]);

  if (loading) {
    return <Loader/>
  }
	return (
		<>
      <a id="comments" tab-index="-1"></a>
      <h2>Kommentare</h2>

        { comments.map((comment, key) => {
          return <div key={key}>
            <p className={`d-flex justify-content-between mb-1 px-3 fw-bold ${ (parseInt(activeUser) === parseInt(comment.user_id)) ? 'text-brand ms-5' : 'me-5'} `}>
              <small>{ comment.author }</small>
              <small>{ comment.created_at } – <a href={`#comment-${(comments.length - key)}`} id={`comment-${(comments.length - key)}`}>#{(comments.length - key)}</a></small>
            </p>
            <div className={`rounded border ${ (parseInt(activeUser) === parseInt(comment.user_id)) ? 'border-brand text-bg-white ms-5' : 'text-bg-light me-5' } px-3 py-3 mb-4`}>
              <p dangerouslySetInnerHTML={{__html: comment.body_html}} />

                {comment.uploads.length > 0 &&
                  <>
                    <hr/>
                    {comment.uploads.length > 1 &&
                      <div className="mb-2">
                        <button className="btn-reset" onClick={() => getAllFiles(comment)} disabled={!!downloadProgress[`all-${comment.id}`]}>
                          <img src="/assets/icons/download.svg" alt="Download"/> <small>Alle Dateien als ZIP herunterladen</small>
                        </button>
                        {downloadProgress[`all-${comment.id}`] && (() => {
                          const { loaded, total } = downloadProgress[`all-${comment.id}`];
                          const percent = total ? Math.round((loaded / total) * 100) : 0;
                          return <>
                            <div className="progress mt-1" style={{ height: '6px' }}>
                              <div className={`progress-bar${total ? '' : ' progress-bar-striped progress-bar-animated'}`} style={{ width: total ? `${percent}%` : '100%' }}></div>
                            </div>
                            <small className="text-muted">{formatFileSize(loaded)}{total ? ` / ${formatFileSize(total)}` : ''}</small>
                          </>;
                        })()}
                      </div>
                    }
                    {comment.uploads.map((upload) => {
                      const fileSize = formatFileSize(upload.size);
                      const progressKey = `${comment.id}-${upload.id}`;
                      const progress = downloadProgress[progressKey];
                      return <div className="d-block mb-1" key={upload.id}>
                        <img src="/assets/icons/file.svg" alt="File" className="me-1"/>
                        <button className="btn-link" onClick={()=>getFile(comment, upload)} disabled={!!progress}><small>{ upload.name }{fileSize && ` (${fileSize})`}</small></button>
                        {progress && (() => {
                          const percent = progress.total ? Math.round((progress.loaded / progress.total) * 100) : 0;
                          return <>
                            <div className="progress mt-1" style={{ height: '6px' }}>
                              <div className={`progress-bar${progress.total ? '' : ' progress-bar-striped progress-bar-animated'}`} style={{ width: progress.total ? `${percent}%` : '100%' }}></div>
                            </div>
                            <small className="text-muted">{formatFileSize(progress.loaded)}{progress.total ? ` / ${formatFileSize(progress.total)}` : ''}</small>
                          </>;
                        })()}
                      </div>
                    })}
                  </>
                }

              {comment.recipients.length > 0 &&
                <>
                  <hr/>
                  {comment.recipients.map((recipient) => {
                    return <div className="d-inline-block mb-1 me-3" key={recipient.id}>
                      <img src="/assets/icons/user.svg" alt="User" className="me-1" />
                      <small>{recipient.full_name}</small>
                    </div>
                  })}
                </>
              }
            </div>
          </div>
        })}
    </>
  )
}
